export interface ImgOrVideoResolution {
  w: number;
  h: number;
}

export function getImageResolution(imgFile: File): Promise<ImgOrVideoResolution> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(imgFile);

    img.onload = () => {
      const result = { w: img.naturalWidth, h: img.naturalHeight };
      URL.revokeObjectURL(objectUrl);
      resolve(result);
    };
    img.onerror = err => {
      URL.revokeObjectURL(objectUrl);
      reject(err);
    };
    img.src = objectUrl;
  });
}

export function getVideoResolution(videoFile: File): Promise<ImgOrVideoResolution> {
  return new Promise(resolve => {
    const video = document.createElement("video");

    video.addEventListener("loadedmetadata", () => {
      resolve({ w: video.videoWidth, h: video.videoHeight });
    });
    video.src = URL.createObjectURL(videoFile);
  });
}
